import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PortalTripType } from '@app/services/api/api.types';

@Component({
  selector: 'lead-details-title',
  templateUrl: './lead-details-title.component.html',
  styleUrls: ['./lead-details-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadDetailsTitleComponent {
  portalTripType = PortalTripType;

  @Input() from: string | undefined;
  @Input() to: string | undefined;
  @Input() textSize: TextSize = 'large';
  @Input() type?: PortalTripType;
}

type TextSize = 'medium' | 'large' | 'small';
